export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13691.2b38b91e.jpg";